module.exports = __webpack_public_path__ + "img/empty-associated-light.9f1a775.svg";